import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { VersetDuJourTextField, VersetDuJourModel } from '@core/models/bible/verset-du-jour-model';
import { VersetDuJourService } from '@core/service/bible/verset-du-jour/verset-du-jour.service';
import { CommonService } from '@core/service/common/common.service';
import { UnsubscribeOnDestroyAdapter } from '@shared';
import { ImportALlModule } from '@shared/imports';
import { OFFSET, EMPTY_GUID } from '@shared/tools/constants/constants';
import { MenuLink } from '@shared/tools/enums/enum-router';
import { EnumText } from '@shared/tools/enums/enum-Text';
import { PermissionCode } from '@shared/tools/enums/permission';
import { Severity } from '@shared/tools/enums/severities';
import { ConfirmationService } from 'primeng/api';
import { PaginatorState } from 'primeng/paginator';

@Component({
  selector: 'app-verset-du-jour',
  standalone: true,
  imports: [
      ImportALlModule,
    ],
  templateUrl: './verset-du-jour.component.html',
  styleUrl: './verset-du-jour.component.scss'
})
export class VersetDuJourComponent extends UnsubscribeOnDestroyAdapter implements OnInit {

  public textField=VersetDuJourTextField;
  public versetDuJourDataList: VersetDuJourModel[] = [];

  constructor(
    public commonService: CommonService,
    public versetDuJourService: VersetDuJourService,
    public elementRef: ElementRef,
    public router: Router,
    public confirmationService: ConfirmationService,
  ){super();}

  ngOnInit() {
    this.loadData();
    this.getPermission();
  }
  async loadData()  {
    this.isLoading=true;
    let userName = this.commonService.authorizationService.sessionAuthService.userConnected.userName;
    this.subs.sink = await this.versetDuJourService.getAllPaginate( this.chantFilter).subscribe({
        next: (result) => {
          this.pagination = result;
          //console.log('pagination',this.pagination);
          if(this.loadfirst){
            this.pageEvent=this.pagination.pageEvent;
            this.loadfirst=false;
          }
          this.versetDuJourDataList = this.pagination.data;
          console.log('versetDuJourDataList:',this.versetDuJourDataList);
          //console.log(result);
        },
        error: (ex) => {
          this.isLoading=false;
          console.log(ex);
        },
        complete: () => {
          this.isLoading=false;
        }
      });
  }
  public get initSearch(): boolean{
    return this.chantFilter.categorieChantId!==''
    || this.chantFilter.groupeChantantId!==''
    || this.chantFilter.isChantChoeur!==''
    || this.chantFilter.searchStr!==''
    || this.chantFilter.typeChant!=='';
  }

  onPageChange(paginatorState: PaginatorState) {
    this.loadfirst = (this.chantFilter.offset != paginatorState.rows);
    this.chantFilter.page = ((paginatorState.page??0)+1);
    this.chantFilter.offset = paginatorState.rows??OFFSET;
    this.loadData();
  }

  clear(data: number) {
    switch (data) {
      case 1:
        this.chantFilter.searchStr='';
        break;
      case 2:
        this.chantFilter.typeChant ='';
        break;
      case 3:
        this.chantFilter.isChantChoeur ='';
        break;
      case 4:
        this.chantFilter.groupeChantantId ='';
        break;
      case 5:
        this.chantFilter.categorieChantId ='';
        break;
      default:
        this.searchValue =''
        this.chantFilter.searchStr='';
        this.chantFilter.categorieChantId ='';
        this.chantFilter.groupeChantantId ='';
        this.chantFilter.isChantChoeur ='';
        this.chantFilter.typeChant ='';
        break;
    }
    this.loadData();
  }

  showForm( isNew: boolean, row?: VersetDuJourModel) {
    if( isNew ){
      this.router.navigate([ MenuLink.VersetDuJour, EMPTY_GUID ]);
    }else{
      this.router.navigate([ MenuLink.VersetDuJour, row?.id  ]);
    }
  }

  async getPermission(){
    this.addButton = await this.commonService.authorizationService.hasPermission([PermissionCode.AddPermissions]);
    this.editButton = await this.commonService.authorizationService.hasPermission([PermissionCode.EditPermissions]);
    this.deleteButton = await this.commonService.authorizationService.hasPermission([PermissionCode.DeletePermissions]);
  }

  onAdd() {
    this.showForm(true );
  }

  onEdit( row: VersetDuJourModel) {
    if(this.editButton){
      this.router.navigate([ MenuLink.VersetDuJour, row.id  ]);
    }
  }

  onDelete( row: VersetDuJourModel) {
    this.confirmationService.confirm({
        message: EnumText.confirmDelete,
        accept: () => {
          this.delete(row);
        }
    });
  }

  public delete(row: VersetDuJourModel) {
    let userName = this.commonService.authorizationService.sessionAuthService.userConnected.userName;
    this.subs.sink = this.versetDuJourService.delete( row.id, ).subscribe({
      next: (result) => {
        if( result ){
          this.commonService.messageService.add({severity:Severity.success, summary: this.textField.id, detail: EnumText.suppresionEffectuee});
          this.loadData();
        }
      },
      error: (ex) => {
        this.isLoading=false;
        console.log(ex);
      },
      complete: () => {
        this.isLoading=false;
      }
    });
  }

  public ststusCss(status: any): string {
    return (status)?`label badge col-green`:`label badge col-red`;
  }

}
